import { isWebCrawler } from '@/modules/headers/isWebCrawler';

function isHeadlessBrowser(userAgent = '') {
  return /headless/i.test(userAgent);
}

export function shouldExcludeFromPerformanceReporting(userAgent = '') {
  return isWebCrawler(userAgent) || isHeadlessBrowser(userAgent);
}
